module.exports = __webpack_public_path__ + "static/media/400340_02.b14cc0f6.png";